import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { JobShareService } from 'src/app/home/available-jobs/job-share.service';

@Component({
  selector: 'app-new-jobs-cards',
  templateUrl: './new-jobs-cards.component.html',
  styleUrl: './new-jobs-cards.component.scss'
})
export class NewJobsCardsComponent {

  @Input() jobs: any[] = [];
  @Input() payload: any = {}
  @Output() triggerRoute = new EventEmitter<any>();
visibleCount = 8;
showAll = false;

  constructor(
    private router: Router,
    private jobShare: JobShareService,

  ) {
    console.log("tttt", this.payload)
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes);

    if (changes['payload']) {
      console.log('Previous:', changes['payload'].previousValue);
      console.log('Current:', changes['payload'].currentValue);
    }
  }

  getAvatarImageUrl(obj: any): string {
    if (obj.companyDetails.logo_path && obj.companyDetails.logo_name && obj.companyDetails.logo_path !== "NA" && obj.companyDetails.logo_name !== "NA") {
      return `${obj.companyDetails.logo_path}/${obj.companyDetails.logo_name}`;
    } else {
      return "assets/images/no-logo.jpg"; // Default placeholder image URL
    }
  }

  getCommaSeparatedLocations(obj: any): string {
    //console.log("locations", obj)
    if (obj?.locations?.length > 0) {
      return obj.locations.slice(0, 2).map((location: any) => location.branch?.city_name || "").join(", ");
    }
    return "";
  }


  formatSalary(job: any): string {
    if (!job) return '';

    const min = this.salaryFormat(job.min_salary);
    const max = this.salaryFormat(job.max_salary);
    const type = job.salary_type || '';
    const frequency = this.frequencyLabel(job.package_label);

    return `₹${min}${type} - ₹${max}${type} / ${frequency}`;
  }

  salaryFormat(value: number | string): string {
    if (!value) return '';

    const salary = Number(value);
    if (isNaN(salary)) return '';

    // Crores
    if (salary >= 10000000) {
      return (salary / 10000000).toFixed(
        salary % 10000000 === 0 ? 0 : 1
      ) + 'Cr';
    }

    // Lakhs
    if (salary >= 100000) {
      return (salary / 100000).toFixed(
        salary % 100000 === 0 ? 0 : 1
      ) + 'L';
    }

    // Thousands
    if (salary >= 1000) {
      return (salary / 1000).toFixed(
        salary % 1000 === 0 ? 0 : 1
      ) + 'K';
    }

    return salary.toString();
  }

  frequencyLabel(value: string): string {
    if (!value) return '';


    switch (value) {
      case 'Y':
        return 'Yearly';

      case 'M':
        return 'Monthly';

      case 'W':
        return 'Weekly';

      case 'D':
        return 'Daily';

      case 'H':
        return 'Hourly';

      default:
        return value; // return original if no match
    }
  }


  onClickJob(event: any) {
    this.triggerRoute.emit(event);
    console.log("route hitting", event)
  }

  toggleJobs() {
    this.showAll = !this.showAll;
  }

}
